import { render, staticRenderFns } from "./oldDefault.vue?vue&type=template&id=3e3dee0b&scoped=true&"
import script from "./oldDefault.vue?vue&type=script&lang=js&"
export * from "./oldDefault.vue?vue&type=script&lang=js&"
import style0 from "./oldDefault.vue?vue&type=style&index=0&id=3e3dee0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3dee0b",
  null
  
)

export default component.exports